import React, { Fragment, useRef } from 'react';
import { ToastProvider } from 'react-toast-notifications';
import { Row, Form } from 'react-bootstrap';
import language from '../../config/es';
import { isGreaterThan } from '../../config/validate';
//redux
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import {
  findRawCountries,
  saveCountry,
  updateCountry,
  deleteCountry,
} from '../../redux/country.duck';
//Session user
import SessionConfig from '../../config/session_config';
//Crud compartido
import {
  useCrudState,
  useCrudLifecycle,
} from '../../components/Crud/crudHooks';
import {
  buildEditColumn,
  renderDeleteAction,
  requireValues,
  stampRows,
} from '../../components/Crud/crudHelpers';
import {
  RequiredFieldsAlertLegacy,
  TextField,
} from '../../components/Crud/CrudFields';
import {
  CrudButtons,
  CrudDataTable,
  CrudPage,
  WIDE_TABLE_COLS,
} from '../../components/Crud/CrudLayout';

const Country = () => {
  const ref = useRef()
  const dispatch = useAppDispatch();
   
  const {
    data,
    refreshState,
    updateState,
    viewNotification,
    handleSelectRow,
    initStateDelete,
    reloadWith,
  } = useCrudState({
    pendingData: false,
    enable: true,
    name: { value: '', error: '' },
    code: { value: '', error: '' },
    dataRows: [],
    errors: [],
    columns: [],
    selectedRows: [],
    id: null,
    showDelete: false,
    auth: JSON.parse(sessionStorage.getItem('user'))
  });
  data.dataRows = useSelector((store) => store.countryReducer.countries);
  //ciclo de vida ---------------------------------------------------
  useCrudLifecycle(ref, data, () => {
    initColumns();
    void loadCountries();
  });
  //hadler ---------------------------------------------------
  const onChange = (event) => {
    switch (event.target.name) {
      case 'name':
        data.name.value = event.target.value;
        data.name.error = '';
        break;
      case 'code':
        data.code.value = event.target.value;
        data.code.error = '';
        break;
      default:
        break;
    }
    refreshState();
  };
  const handleButtonEdit = (row) => {
    data.id = row.id;
    data.name.value = row.name;
    data.code.value = row.code;

    refreshState();
  };
  const handleDelete = () => {
    void disableData();
  };
  //functions ---------------------------------------------------
  const contextActions = renderDeleteAction(handleDelete, data.enable);
  const disableData = async () => {
    if (data.selectedRows.length > 0) {
      stampRows(data.selectedRows, {
        status: 0,
        authUser: data.auth.id.user.userId,
      });
      initStateDelete(false);

      let response = await dispatch(deleteCountry(data.selectedRows));

      if (response.code !== undefined) {
        viewNotification(response.message, 'error');
        initStateDelete(true);
      } else {
        viewNotification(language.messages.msmDisableAll, 'success');
        data.enable = true;
        data.showDelete = true;
        data.pendingData = false;
        void reloadData();
      }
    }
  };

  const clearError = async () => {
    data.errors = [];
    data.name.error = '';
    data.code.error = '';
  };
  const loadCountries = async () => {
    updateState(true, 'pendingData');
    let lsCountries = await dispatch(
      findRawCountries(data.auth.id.user.userId)
    );
    if (lsCountries.code !== undefined) {
      viewNotification(lsCountries.message, 'error');
      data.dataRows = [];
    } else {
      data.dataRows = lsCountries;
    }
    updateState(false, 'pendingData');
  };

  const initColumns = () => {
    data.columns = [
      {
        name: language.messages.lblCode,
        sortable: false,
        wrap: true,
        width: '100px',
        cell: (row) => (
          <span>
            <div className="text-primary text-uppercase small">{row.code}</div>
          </span>
        ),
      },
      {
        name: language.messages.lblName,
        sortable: false,
        wrap: true,
        width: '300px',
        cell: (row) => (
          <span>
            <div className=" text-uppercase small">{row.name}</div>
          </span>
        ),
      },
      buildEditColumn(handleButtonEdit, {
        name: language.messages.lblFunctions,
        width: '10px',
      }),
    ];
    refreshState();
  };
  const validate = () => {
    void clearError();

    requireValues(data, ['name', 'code']);

    if (!isGreaterThan(5, data.code.value.length)) {
      data.errors.push('code.error');
      data.code.error = language.messages.society.errorCode;
    }
    refreshState();
  };

  const clearForm = () => {
    data.name = { value: '', error: '' };
    data.code = { value: '', error: '' };
    data.id = null;
    refreshState();
  };
  const saveData = async () => {
    validate();

    if (data.errors.length === 0) {
      updateState(false, 'enable');
      let json = {
        id: data.id,
        name: data.name.value,
        code: data.code.value,
        status: 1,
        userAdmin: sessionStorage.getItem('username'),
        authUser: data.auth.id.user.userId,
        societyId: ''
      };

      let response = '';
      if (data.id === null) {
        response = await dispatch(saveCountry(json));
      } else {
        response = await dispatch(updateCountry(json));
      }

      if (response.messageResponse === undefined) {
        updateState(true, 'pendingData');
        await reloadData();

        viewNotification(
          language.messages.msmRegister.replace('{0}', data.name.value),
          'success'
        );
        clearForm();
        updateState(false, 'pendingData');
      } else {
        updateState(true, 'enable');
        viewNotification(response.messageResponse, 'error');
      }
    }
  };
  const cleaningForm = () => {
    void clearError();
    clearForm();

    viewNotification(language.messages.success_clean_data, 'success');
  };
  const reloadData = () => reloadWith(loadCountries);
  const reloadDataEnable = async () => {
    await loadCountries();
    refreshState();
  };
  //render----------------------------------------------------
  return (
    <Fragment>
    <SessionConfig ref={ref}/>
      <CrudPage
        {...WIDE_TABLE_COLS}
        formTitle={language.messages.country.title_country_form}
        form={
          <Form autoComplete="off">
            <RequiredFieldsAlertLegacy />

            <Row>
              <TextField
                col={{ md: 8, sm: 12 }}
                label={language.messages.lblName}
                name="name"
                field={data.name}
                onChange={onChange}
              />
              <TextField
                col={{ md: 4, sm: 12 }}
                label={language.messages.lblCode}
                name="code"
                field={data.code}
                onChange={onChange}
              />
            </Row>
            <CrudButtons
              data={data}
              withLoading
              primary
              small={false}
              reloadIcon="fa-refresh"
              onSave={saveData}
              onClear={cleaningForm}
              onReload={reloadDataEnable}
            />
          </Form>
        }
        tableTitle={language.messages.country.title_country_register}
        table={
          <CrudDataTable
            data={data}
            rows={data.dataRows}
            scrollHeight="500px"
            onSelect={handleSelectRow}
            actions={contextActions}
          />
        }
      />
    </Fragment>
  );
};
const App = () => (
  <ToastProvider>
    <Country />
  </ToastProvider>
);
export default App;
